export type UserMenuItemKey = 'myData' | 'settings' | 'selectAccount' | 'changePassword' | 'logout';

export interface UserMenuItem {
  key: UserMenuItemKey;
  labelKey: string;
  /** Destino de navegação; `null` marca o item de ação (logout). */
  path: string | null;
}

export interface UserMenuVisibility {
  myData: boolean;
  settings: boolean;
  selectAccount: boolean;
  changePassword: boolean;
}

/** Ordem de declaração do dropdown legado; a ordem desta lista É o contrato de layout. */
export const USER_MENU_ITEMS: readonly UserMenuItem[] = [
  { key: 'myData', labelKey: 'navbar.userMenu.myData', path: '/meus-dados' },
  {
    key: 'settings',
    labelKey: 'navbar.userMenu.settings',
    path: '/configuracoes/list-configuracoes',
  },
  { key: 'selectAccount', labelKey: 'navbar.userMenu.selectAccount', path: '/conta/select-conta' },
  { key: 'changePassword', labelKey: 'navbar.userMenu.changePassword', path: '/alterar-senha' },
  { key: 'logout', labelKey: 'navbar.userMenu.logout', path: null },
];

/** Subsequência visível da lista canônica; logout nunca é filtrado. */
export function visibleUserMenuItems(visibility: UserMenuVisibility): readonly UserMenuItem[] {
  return USER_MENU_ITEMS.filter((item) => item.key === 'logout' || visibility[item.key]);
}
